import { produce } from "immer";
import { getDefaultBrandProfile } from "src/redux/company/defaultData";
import _ from "lodash";
import { tBrandLandingAction, tBrandLandingState, tSetBrandDataAction } from "./types";

const kDefaultBrandLandingState: tBrandLandingState = {
  brandData: getDefaultBrandProfile(),
};

type tpHandleSetBrandData = (state: tBrandLandingState, action: tSetBrandDataAction) => tBrandLandingState;
const handleSetBrandData: tpHandleSetBrandData = (state, action) => {
  state.brandData = _.merge<tBrandLandingState["brandData"], tSetBrandDataAction["brandData"]>(
    getDefaultBrandProfile(),
    action.brandData,
  );
  return state;
};

type tpBrandLandingReducer = (state: tBrandLandingState, action: tBrandLandingAction) => tBrandLandingState;
export const BrandLandingReducer: tpBrandLandingReducer = produce((state = kDefaultBrandLandingState, action) => {
  switch (action.type) {
    case "SET_BRAND_LANDING_DATA":
      return handleSetBrandData(state, action);
    case "SET_BRAND_PROMO_DATA":
      state.brandData.promotions = action.brandData;
      return state;
    default:
      return state;
  }
});
